<p-panel
  header="Clinical Information"
  [toggleable]="true"
  [collapsed]="isPASComplete"
  toggler="header"
>
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-down" [class]="{ 'rotate-180': !collapsed }"></i>
  </ng-template>
    @if (isTabAvailable && clinicalInformation && !isPASComplete) {
      <div class="f-io">
        <mnc-formio
          lazyComponent
          [form]="formConfig"
          [submission]="formData"
          [readOnly]="true"
          (ready)="onFormReady($event)"
        ></mnc-formio>
      </div>
    } @else {
      <p>
        {{ isTabAvailable ? 'Clinical information bypassed.' : 'The Clinical Information tab is not available for this type of authorization.' }}
      </p>
    }
</p-panel>
